import React from 'react'

export default function UserAvatar(props) {
  const { userInfo: { name, imageURL }, imageClasses, className, notRounded } = props

  const getNameInitials = () => {
    const nameArr = name?.trim().split(/\s+/) || [];
    const firstName = nameArr[0] || '';
    const lastName = nameArr.length > 1 ? nameArr[nameArr.length - 1] : '';
    const lastNameOrLastChar = lastName || firstName.charAt(1);
    const initials = `${firstName.charAt(0).toUpperCase()}${lastNameOrLastChar.charAt(0).toUpperCase()}`;
    return initials
  }

  return (
    <>
      {imageURL ?
        <img
          src={imageURL}
          alt="user_profile_img"
          style={{ objectFit: "contain" }}
          className={`${!notRounded ? 'rounded-circle' : ''} ${imageClasses}`}
        /> :
        <span
          className={`d-flex justify-content-center align-items-center text-primary bg-primary-light ${!notRounded ? 'rounded-circle' : ''} ${className}`}
        >
          {getNameInitials()}
        </span>
      }
    </>
  )
}
